import React from 'react';
import { Link } from 'react-router-dom';

function NavBar() {
  return (
    <nav>
      <Link to="/">Home</Link>
      <Link to="/services">Services</Link>
      <Link to="/about">About</Link>
      <a href="https://login.crawford-bank.ca/portal" target="_blank" rel="noopener noreferrer">Client Login</a>
      <a href="https://login.crawford-bank.ca/portal" target="_blank" rel="noopener noreferrer">Investors Login</a>
      <a href="https://login.crawford-bank.ca" target="_blank" rel="noopener noreferrer">Admin Login</a>
      <Link to="/contact">Contact</Link>
    </nav>
  );
}

export default NavBar;
